import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import AppSummarySearchBar from '@/common/components/form-inputs/AppSummarySearchBar';
import AppDropDownMenu from '@/common/components/form-inputs/AppDropDownMenu';
import { InformationPageFilter } from '@/api/DTO/information/information.interface';
import { OnoffType } from '@/api/enum/common.enum';

export default function InformationListSummaryFilterSection() {
	const { t } = useTranslation();
	const { control } = useFormContext<InformationPageFilter>();

	const statusList = [
		{ id: '', name: t('common.all') },
		{ id: OnoffType.on, name: t('information.on') },
		{ id: OnoffType.off, name: t('information.off') },
	];

	return (
		<Grid container rowSpacing={2} columnSpacing={1}>
			<Grid item xs={3}>
				<AppSummarySearchBar
					name='searchString'
					control={control}
					placeholder={t('common.search')}
				/>
			</Grid>
			<Grid item xs={2.5}>
				<AppDropDownMenu
					control={control}
					name='published'
					label={t('information.informationStatus')}
					options={statusList}
					size='small'
				/>
			</Grid>
		</Grid>
	);
}
